// extracted by mini-css-extract-plugin
module.exports = {"or":"OrSeparator_or__jyVRE","text":"OrSeparator_text__kodgO","line":"OrSeparator_line__1296S"};